/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".fas[_ngcontent-%COMP%]{background-image:url(star-on.ac6ad5381c6c4d1ac409.svg);background-repeat:no-repeat;display:inline-block;height:32px;width:32px}.far[_ngcontent-%COMP%]{background-image:url(star-off.50d943fb682b72a59e19.svg);background-repeat:no-repeat;display:inline-block;height:32px;width:32px}"];
export { styles as styles };
